import { PinAccessForm } from "../../shared/components/PinAccessForm";
import type { useShiftProductionFormWorkspace } from "../shift-production-form/useShiftProductionFormWorkspace";

type SessionWorkspace = ReturnType<typeof useShiftProductionFormWorkspace>;

export function ApproverPinLogin({ workspace }: { workspace: SessionWorkspace }) {
  return <PinAccessForm
    verify={(pin) => workspace.verifyApproverPin(pin).then(workspace.acceptSession)}
    eyebrow="Üretim yönetimi"
    title="Form onayına giriş"
    description="Size tanımlanan 6 haneli kişisel onaycı PIN’inizi girin."
    label="Onaycı PIN’i"
    submitLabel="Onay kuyruğunu aç"
    scope="Bu PIN yalnız size atanmış vardiya formu onaylarını açar."
  />;
}
